// /**
//  * Escolas Page
//  */
// import React, { Component } from 'react';
// // Alertas
// import { NotificationManager } from 'react-notifications';
// import RctPageLoader from 'Components/RctPageLoader/RctPageLoader';
// import {DynamicForm} from 'Components/DynamicForm';
// import srv from 'Services/srv';
// import {FixedTab} from 'Components/Tabs';
// import {ActionTable} from 'Components/Tables';
// import { Helmet } from "react-helmet";
// import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// import {formatDateTime} from 'Helpers/helpers';

// export default class ProdutoPertoUsuario extends React.Component {
//     state = {
//         carregando: false,
//         produtoPertoId: 0,
//         usuarioId: 0,
//         usuarioBuscar: {
//             cpf: '',
//             nome: '',
//             email: ''
//         },
//         comboProdutosPerto: [],
//         usuarioProdutoPertoVinculo: {},
//         profsBusca: []
//     }

//     componentDidMount(){
//         this.carregarComboProdutosPerto();
//     }

//     carregarComboProdutosPerto = () => {
//         srv.post('produtosPerto/listar')
//         .then(comboProdutosPerto => this.setState({comboProdutosPerto}))
//         .catch(err => {
//             console.log(err);
//             NotificationManager.error('Erro ao listar os produtos Perto.');
//         });
//     }

//     buscar = (usuarioBuscar) => {
//         this.setState({usuarioBuscar, carregando: true});

//         srv.post('profissionais/listar', usuarioBuscar)
//         .then(profissionais => {
//             if(profissionais.length === 0) return NotificationManager.warning('Nenhum profissional localizado.');

//             this.setState({usuarioBuscar, profsBusca: profissionais, carregando: false, usuarioProdutoPertoVinculo: {}});
//         })
//         .catch(err => NotificationManager.error('Erro ao listar os profissionais: ' + err));
//     }

//     campoFiltroProdutoPerto = () => {
//         const {produtoPertoId, comboProdutosPerto} = this.state;

//         return {
//             produtoPertoId: {
//                 name: 'Produto Perto',
//                 type: 'select',
//                 value: produtoPertoId,
//                 array: {
//                     array: comboProdutosPerto,
//                     value: 'id',
//                     desc: 'nome'
//                 },
//                 emptyItem: true,
//                 emptyItemText: '(Selecione)',
//                 emptyItemValue: 0,
//                 onChangeAction: this.selecionarProdutoPerto
//             }
//         }
//     }

//     camposVinculoUsuarioProdutoPerto = (usuarioProdutoPertoVinculo) => {
//         const campos = {
//             nome: {
//                 name: 'Profissional',
//                 type: 'text',
//                 value: usuarioProdutoPertoVinculo.usuarioNome,
//                 lineSpacing: 4,
//                 enabled: false
//             },
//             email: {
//                 name: 'Email',
//                 type: 'text',
//                 value: usuarioProdutoPertoVinculo.usuarioEmail,
//                 lineSpacing: 4,
//                 enabled: false
//             },
//             expiracaoAcesso: {
//                 name: 'Acesso expira em',
//                 type: 'date',
//                 value: formatDateTime(usuarioProdutoPertoVinculo.expiracaoAcesso, 'Y-M-D'),
//                 lineSpacing: 4
//             }
//         }

//         if(!usuarioProdutoPertoVinculo.produtoPertoId){
//             campos.mensagemVinculo = {
//                 name: 'Profissional não vinculado.',
//                 type: 'text',
//                 value: 'O profissional não tem vínculo com o produto selecionado. Clique em "Criar vínculo" caso deseje criar um.',
//                 enabled: false
//             }
//         }

//         return campos;
//     }

//     selecionarProdutoPerto = produtoPertoId => {
//         this.setState({produtoPertoId});

//         const {usuarioId} = this.state;

//         if(produtoPertoId && usuarioId){
//             this.carregarUsuarioProdutoPerto(produtoPertoId, usuarioId);
//         }
//     }

//     selecionarUsuario = usuarioId => {
//         this.setState({usuarioId});

//         const {produtoPertoId} = this.state;

//         if(!produtoPertoId) return NotificationManager.warning('Selecione o produto.')

//         if(produtoPertoId && usuarioId){
//             this.carregarUsuarioProdutoPerto(produtoPertoId, usuarioId);
//         }
//     }

//     carregarUsuarioProdutoPerto = (produtoPertoId, usuarioId) => {
//         srv.post('produtosPerto/carregarUsuario', {produtoPertoId, usuarioId})
//         .then(usuarioProdutoPertoVinculo => {
//             console.log('usuarioProdutoPertoVinculo', usuarioProdutoPertoVinculo)
//             this.setState({usuarioProdutoPertoVinculo});
//         })
//         .catch(err => {
//             NotificationManager.error('Erro ao carregar o vínculo entre usuário e produto');
//             console.log(err)
//         })
//     }

//     buscaForm = (usuarioBuscar) => {
//         return {
//             nome: {
//                 name: 'Nome',
//                 type: 'text',
//                 value: usuarioBuscar.nome,
//                 lineSpacing: 5
//             },
//             email: {
//                 name: 'Email',
//                 type: 'text',
//                 value: usuarioBuscar.email,
//                 lineSpacing: 4
//             },
//             cpf: {
//                 name: 'CPF',
//                 type: 'text',
//                 value: usuarioBuscar.cpf,
//                 lineSpacing: 3
//             }
//         }
//     }

//     vincularUsuarioProdutoPerto = form => {
//         const {usuarioId, produtoPertoId} = this.state;

//         const vinculoCriar = {
//             usuarioId,
//             produtoPertoId,
//             expiracaoAcesso: form.expiracaoAcesso
//         }

//         srv.post('produtosPerto/vincularUsuario', vinculoCriar)
//         .then(resultado => {
//             NotificationManager.success('Profissional vinculado ao produto.');
//             this.carregarUsuarioProdutoPerto(produtoPertoId, usuarioId);
//         })
//         .catch(err => NotificationManager.error('Erro ao vincular o grupo: ' + err));
//     }

//     editarVinculo = form => {
//         const {usuarioId, produtoPertoId} = this.state;

//         const vinculoEditar = {
//             usuarioId,
//             produtoPertoId,
//             expiracaoAcesso: form.expiracaoAcesso
//         }

//         srv.post('produtosPerto/editarUsuario', vinculoEditar)
//         .then(() => {
//             NotificationManager.success('Vínculo editado.');
//             this.carregarUsuarioProdutoPerto(produtoPertoId, usuarioId);
//         })
//         .catch(err => NotificationManager.error('Erro ao vincular o grupo: ' + err));
//     }

//     render(){
//         const {usuarioBuscar, profsBusca, usuarioProdutoPertoVinculo} = this.state;

//         const fProdutoPerto = {
//             form: this.campoFiltroProdutoPerto(),
//             title: 'Produto Perto',
//             history: this.props.history
//         }

//         const fBuscaUsuario = {
//             form: this.buscaForm(usuarioBuscar),
//             title: 'Buscar usuário',
//             submit: {
//                 label: 'Buscar',
//                 action: this.buscar
//             }
//         }

//         const fProdutoPertoUsuario = {
//             form: this.camposVinculoUsuarioProdutoPerto(usuarioProdutoPertoVinculo),
//             title: 'Usuário x Produto Perto',
//             submit: usuarioProdutoPertoVinculo.produtoPertoId ? {
//                 label: 'Salvar',
//                 action: this.editarVinculo
//             } : {
//                 label: 'Criar vínculo',
//                 action: this.vincularUsuarioProdutoPerto
//             }
//         }

//         const tBusca = {
//             title: 'Profissionais localizados',
//             array: profsBusca,
//             key: 'usuarioId',
//             onLineClick: this.selecionarUsuario,
//             columns: [
//                 {
//                     name: 'nome',
//                     label: 'Nome',
//                     style: {fontWeight: 'bolder'}
//                 },
//                 {
//                     name: 'email',
//                     label: 'Email'
//                 }
//             ]
//         };

//         return(
//             <div>
//                 <Helmet>
//                     <title>Produto Perto x Usuário</title>
//                     <meta name="description" content="Produto Perto x Usuário" />
//                 </Helmet>
//                 <PageTitleBar title="Produto Perto x Usuário" match={this.props.match} history={this.props.history} />
//                 <DynamicForm structure={fProdutoPerto}/>
//                 <DynamicForm structure={fBuscaUsuario}/>
//                 {usuarioProdutoPertoVinculo.usuarioId ?
//                     <DynamicForm structure={fProdutoPertoUsuario}/>
//                 :
//                     <ActionTable structure={tBusca}/>
//                 }
//             </div>
//         );
//     }
// }

// import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ProdutoPertoUsuario from "./ProdutoPertoUsuario";

const IndexPacote = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      {/* <Redirect exact from={`${match.url}/`} to={`${match.url}`} /> */}
      <Route path={`${match.url}/`} component={ProdutoPertoUsuario} />
    </Switch>
  </div>
);

export default IndexPacote;
